import _extends from "@babel/runtime/helpers/esm/extends";
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { themeTokens5_4 } from "../../themes/consts";
export var getComboBoxTheme = function getComboBoxTheme(theme, viewMode) {
  return ThemeFactory.create(_extends({
    menuOffsetY: theme.comboboxMenuOffsetY
  }, viewMode === 'multiline' || viewMode === 'multiline-editing' ? themeTokens5_4 : {}), theme);
};